// extracted by mini-css-extract-plugin
export default {"pageHeader":"OrderInfoContainer_pageHeader__QMha2","customPayBtn":"OrderInfoContainer_customPayBtn__tzmX8","btnContainer":"OrderInfoContainer_btnContainer__SsSx1"};